import { LitElement, css, html, unsafeCSS } from "lit";
import { customElement } from "lit/decorators.js";
import { connectedProperty } from "../../../../infrastructure/state/connected-property";
import { isEmptyDataAndOtherLoading, isSomeCollectionLoadedAndOtherLoading } from "../selectors";
import styles from "./styles.css?inline";
import { template } from "./template";

//@ts-ignore
@customElement("activity-history-busy")
export class ActivityHistoryBusy extends LitElement {
  render() {
    return html`${template(this)}`;
  }

  static styles = css`
    ${unsafeCSS(styles)}
  `;

  @connectedProperty(isSomeCollectionLoadedAndOtherLoading)
  isSomeCollectionLoadedAndOtherLoading: boolean;

  @connectedProperty(isEmptyDataAndOtherLoading)
  isEmptyDataAndOtherLoading: boolean;

  get skeletons() {
    return Array.from({ length: 12 }, () => html`<dss-skeleton width="100" height="10"></dss-skeleton>`);
  }
}
